import { render, staticRenderFns } from "./ProofworkView.vue?vue&type=template&id=5a3bec9f"
import script from "./ProofworkView.vue?vue&type=script&lang=js"
export * from "./ProofworkView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports